/* eslint-disable no-plusplus */
import './theme/index';
import 'lazysizes';
